import { initializeAuthUrls } from 'ihunter-pathfinder-components';
const { setEmbeddedResetPasswordUrl, setEmbeddedVerifyEmailUrl } = initializeAuthUrls();

export function useActionRouteHandler() {

    // Redirect from the /action route to the specified continueUrl
    // Handles custom email action links: mode=signIn, resetPassword
    // Sign In: https://accounts.ihunterapp.com/action?apiKey=<key>&mode=signIn&oobCode=<actionCode>&continueUrl=https%3A%2F%2Faccounts.ihunterapp.com%2Flogin%26continue%3Dweb%26lang%3Den
    // Reset Password: https://accounts.ihunterapp.com/action?apiKey=<key>>&mode=resetPassword&oobCode=<actionCode>>&continueUrl=https://accounts.ihunterapp.com/reset-password&lang=en
    // See https://firebase.google.com/docs/auth/admin/email-action-links
    const redirectFromActionRoute = (to) => {
        try {
            console.log(`redirectFromActionRoute`, to.query);
            return to.query?.continueUrl ? getRedirectParams(to) : getRedirectParamsFromLegacyUrl(to);
        } catch (error) {
            console.error(`redirectFromActionRoute: path ${to.fullPath} is invalid, redirecting to root`, error);
            return { path: '', query: to.query };
        }
    }

    const getRedirectParams = (to) => {
        const url = new URL(to.query.continueUrl);
        console.log(`getRedirectParams url`, url.pathname);
        const query = Object.assign({}, to.query);
        delete query.continueUrl;
        for (const [key, value] of url.searchParams) {
            if (key === 'resetPasswordUrl' && value) {
                setEmbeddedResetPasswordUrl(value);
            } else if (key === 'verifyEmailUrl' && value) {
                setEmbeddedVerifyEmailUrl(value);
            } else {
                query[key] = value;
            }
        }
        console.log(`getRedirectParams query`, query);
        return { path: url.pathname, query: query };
    }

    // Legacy reset password url does not have the 'continueUrl' param: 
    // https://accounts.ihunterapp.com/action?mode=resetPassword&oobCode=<actionCode>&lang=en
    const getRedirectParamsFromLegacyUrl = (to) => {
        const url = new URL(`${window.location.origin}\\reset-password`);
        console.log(`getRedirectParamsFromLegacyUrl path`, url.pathname);
        const query = Object.assign({}, to.query);
        for (const [key, value] of url.searchParams) {
            query[key] = value;
        }
        console.log(`getRedirectParamsFromLegacyUrl query`, query);
        return { path: url.pathname, query: query };
    }

    return {
        redirectFromActionRoute
    };
}
